import ymvc5 from "../assets/yasmavoca/1.png";
import ymvc2 from "../assets/yasmavoca/duwa.png";
import ymvc3 from "../assets/yasmavoca/tiga.png";
import ymvc4 from "../assets/yasmavoca/empat.png";
import ymvc1 from "../assets/yasmavoca/limo.png";

const ymvcImages = [ymvc1, ymvc2, ymvc3, ymvc4, ymvc5];

import utama from "../assets/finance/Pertama.png";
import fnc1 from "../assets/finance/satu.png";
import fnc2 from "../assets/finance/dua.png";
import fnc5 from "../assets/finance/lima.png";
import fnc6 from "../assets/finance/enam.png";
import fnc7 from "../assets/finance/tujuh.png";
import financeThumb from "../assets/finance/thumbnail.png";

const fncImages = [utama, fnc1, fnc2, fnc5, fnc6, fnc7];

import tm1 from "../assets/TM/pertama.png";
import tm2 from "../assets/TM/kedua.png";
import tm3 from "../assets/TM/ketiga.png";
import tm4 from "../assets/TM/keempat.png";
import tm5 from "../assets/TM/kelima.png";
import tm6 from "../assets/TM/keenam.png";
import tm7 from "../assets/TM/ketujuh.png";
import tm8 from "../assets/TM/kedelapan.png";
import tm9 from "../assets/TM/kesembilan.png";
import tmThumb from "../assets/TM/Thumbnail.png";

const tmImages = [tm1, tm2, tm3, tm4, tm5, tm6, tm7, tm8, tm9];

import inter1 from "../assets/inter/satu.png";
import inter2 from "../assets/inter/dua.png";
import inter3 from "../assets/inter/tiga.png";
import inter4 from "../assets/inter/empat.png";
import interThumb from "../assets/inter/thiumnail.png";

const interImg = [inter1, inter2, inter3, inter4];
import tmAPI from "../assets/TM/as.png";
import D from "../assets/Discover JagoScript — a digital marketplace built to empower your ideas.Sell and buy digital pr.webp";

import sign1 from "../assets/sign/screencapture-localhost-5173-2026-02-10-11_23_53.png";
import sign2 from "../assets/sign/screencapture-localhost-5173-login-2026-02-10-11_24_26.png";
import sign3 from "../assets/sign/screencapture-localhost-5173-dashboard-2026-02-10-11_24_37.png";
import sign4 from "../assets/sign/screencapture-localhost-5173-levels-2026-02-10-11_24_50.png";
import sign5 from "../assets/sign/screencapture-localhost-5173-lesson-6989db3558c5be249faf8b9c-2026-02-10-11_25_09.png";
import sign6 from "../assets/sign/screencapture-localhost-5173-profile-2026-02-10-11_25_23.png";
import signThumb from "../assets/sign/thumnail.png";

import signVideo from "../assets/sign/WhatsApp Video 2026-02-14 at 17.38.44.mp4";

const signImages = [sign1, sign2, sign3, sign4, sign5, sign6];

import slearnThumb from "../assets/Slearn/Thumnail.png";

import polThumb from "../assets/polaries/Thumnail.png";
import polImg1 from "../assets/polaries/image.png";
import polImg2 from "../assets/polaries/Dua.png";
import polImg3 from "../assets/polaries/Tiga.png";

const polImages = [polImg1, polImg2, polImg3];

export const projects = [
  {
    id: 9,
    name: "Polareis — Marketing Platform",
    description:
      'Polareis is an all-in-one marketing platform — "built by marketers, for marketers" — that unifies planning, content creation, multi-platform publishing, and performance analytics in a single workspace. At Newgen Development I built the Polareis.io marketing website in Next.js: 7+ feature- and audience-segmented subpages with dynamic content sourced from Google Sheets and Figma design references.',
    techStack: [
      "Next.js",
      "React",
      "TypeScript",
      "Tailwind CSS",
      "Google Sheets API",
    ],
    image: polImages,
    thumbnail: polThumb,
    github: null,
    demo: "https://polareis.io/",
    featured: true,
    impact:
      "Live marketing site for a MarTech SaaS — 7+ dynamic, audience-segmented pages",
    type: "client",
  },
  {
    id: 8,
    name: "Slearn — Trading Journal SaaS",
    description:
      "Slearn is a trading journal & performance analytics SaaS for 2,500+ active traders to log trades, define strategies, enforce risk rules, and analyze performance — competing with TradeZella and TraderSync. I built RESTful APIs in NestJS for trade logging, strategy management, and analytics; developed React/TypeScript components including the dashboard, Trading Lab strategy builder, and daily summary calendar; designed MongoDB schemas for core entities; and integrated Midtrans for subscription billing.",
    techStack: [
      "React",
      "TypeScript",
      "NestJS",
      "MongoDB",
      "Midtrans",
      "REST API",
    ],
    image: [slearnThumb],
    thumbnail: slearnThumb,
    github: null,
    demo: null,
    featured: true,
    impact: "Trading journal & analytics SaaS serving 2,500+ active traders",
    type: "client",
  },
  {
    id: 7,
    name: "Sign Language Learning Platform",
    description:
      "Interactive sign language learning platform built with AI-powered hand recognition. Created to help a close friend who is unable to speak — their classmates struggled to understand them, so I built this app to bridge the communication gap. Users can learn sign language through real-time hand gesture scanning that recognizes which letter they're signing, making learning intuitive and engaging.",
    techStack: [
      "React",
      "Nest.js",
      "TensorFlow.js",
      "AI Hand Recognition",
      "MongoDB",
      "Tailwind CSS",
    ],
    image: signImages,
    thumbnail: signThumb,
    github: null,
    demo: "https://sanssign.netlify.app/",
    featured: true,
    impact: "Bridging communication gaps through AI-powered accessibility",
    comingSoon: false,
    video: signVideo,
    type: "personal",
  },
  {
    id: 5,
    name: "Finance Web Platform",
    description:
      "Enterprise-level finance web platform developed for PT Viura Indo Tirta (water utility company in Bogor). The system handles transaction management, financial reporting, invoicing, and data visualization dashboards to support daily financial operations.",
    techStack: [
      "React",
      "TypeScript",
      "Redux Toolkit",
      "Ant Design",
      "Tailwind CSS",
      "frontend engineering",
    ],
    image: fncImages,
    thumbnail: financeThumb,
    github: null,
    demo: null,
    impact:
      "Zero critical production issues • 50+ reusable components • ~40% faster feature delivery",
    type: "client",
  },
  {
    id: 2,
    name: "Task Management System Frontend",
    description:
      "(Email : admin@gmail.com | Password:admin123 | (gmail : developer@gmail.com | Password:dev123) Frontend application for a task management system that helps teams organize tasks, track progress, and manage workflows efficiently. Features include authentication, task CRUD operations, dashboards, and state management for scalable usage. ",
    techStack: [
      "React",
      "Node.js",
      "MongoDB",
      "Express",
      "Redux",
      "fullstack engineering",
    ],
    image: tmImages,
    thumbnail: tmThumb,
    github: "https://github.com/rizkym4l/PM_fe",
    demo: "https://task-manager-rizkimaulanaarf.netlify.app/dashboard",
    impact: "Scalable team workflow management with real-time task tracking",
    type: "personal",
  },
  {
    id: 3,
    name: "Web-based Internal Complaint System",
    description:
      "Internal web application developed for PT 4net Prima Solusi (Depok) to manage employee and internal complaints. The system allows users to submit complaints online, communicate with administrators via a real-time chat feature, and track complaint resolution status to improve transparency and operational efficiency.",
    techStack: ["React", "Laravel", "MySQL", "Tailwind CSS"],
    image: interImg,
    thumbnail: interThumb,
    github: null,
    demo: null,
    impact:
      "Improved operational efficiency • Enhanced issue resolution transparency",
    type: "client",
  },
  {
    id: 4,
    name: "Creative Hub Platform",
    description:
      "Creative hub web platform designed for content creators and communities at Jagoscript. Features dynamic UI components, smooth interactivity, and modular architecture using Livewire and Alpine.js without requiring full page reloads.",
    techStack: ["Livewire", "Laravel", "Tailwind CSS", "Alpine.js"],
    image: D,
    github: null,
    demo: null,
    impact: "Optimized performance • Reduced average load time by up to 45%",
    type: "client",
  },
  {
    id: 6,
    name: "Task Management System API",
    description:
      "RESTful API for a task management system that handles authentication, task data, user management, and business logic. Built with a scalable architecture to support frontend applications and future integrations.",
    techStack: [
      "Node.js",
      "MongoDB",
      "Express",
      "JWT",
      "REST API",
      "backend engineering",
    ],
    image: tmAPI,
    github: "https://github.com/rizkym4l/PM_api",
    demo: "https://exquisite-llama-3cb720.netlify.app/",
    impact: "Scalable RESTful architecture with JWT authentication",
    type: "personal",
  },
  {
    id: 1,
    name: "Yasmavoca Web Profile",
    description:
      "Company profile website for Yasmavoca, an avocado shop based in Sukabumi, Indonesia. Designed with a clean and modern UI to showcase brand identity, products, and business information. Built using React and Tailwind CSS with full responsiveness across devices.",
    techStack: [
      "React",
      "JavaScript",
      "Tailwind",
      "HTML",
      "frontend engineering",
    ],
    image: ymvcImages,
    github: null,
    demo: null,
    impact: "Clean brand showcase with full responsive design",
    type: "client",
  },
];
